/** The stored field the denominator needs. Structural, so any selection carrying it fits. */
export interface ChipTotalTaskSet {
	readonly instanceCount?: number | null;
}

/**
 * The denominator for "3 of 26", shared by the timeline bar and the task modal.
 *
 * The scoping chip is NOT a caller: TaskSetChip.tsx is handed `instanceCount`
 * as a prop by ProjectScopingPage.tsx and reads it the same way, because it is
 * presentation over a number rather than over a task set.
 *
 * The total is the number of tasks the set has now. A task's position is its
 * place among those tasks and closes the gaps left by deleted ones, so the
 * position never exceeds this total, and deleting a task shrinks both together.
 */
export const taskSetChipTotal = (taskSet?: ChipTotalTaskSet | null): number | null => taskSet?.instanceCount ?? null;
